/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    number, string, shape, object,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Media from 'react-media';
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { main as MainStyle } from '../../style/main';
import CUSTOM_BREAKPOINTS from '../../../../helpers/customBreakpoints';
import DesktopAccountHome from './DesktopAccountHome/DesktopAccountHome';
import { getBrand } from '../../state/ducks/Common/Common-Selectors';
import ProfileAndPassword from '../ProfileAndPassword/ProfileAndPassword';

const styles = ({ typography, palette }) => MainStyle(typography, palette);
const baseURL = '/account';
const listItem = [
    /* {
        id: 1,
        label: 'Gift List',
        url: `${baseURL}/gift-list`,
        flag: 'is-account-gift-list-enabled',
    }, */
    { id: 1, label: 'MY PROFILE', url: `${baseURL}/profile` },
    { id: 2, label: 'MY ORDERS', url: `${baseURL}/orders` },
    /* { id: 3, label: 'Address Book', url: `${baseURL}/address-book` }, */
    /* {
        id: 4,
        label: 'Manage Subscriptions',
        url: `${baseURL}/subscriptions`,
        flag: 'is-account-subscription-enabled',
    }, */
    /* { id: 5, label: 'Payment & Billing', url: `${baseURL}/billing-address` }, */
    { id: 3, label: 'RESET PASSWORD', url: `${baseURL}/reset-password` },
    /* { id: 7, label: 'Change Email', url: `${baseURL}/change-email` }, */
    /* { id: 8, label: 'Email Preference', url: `${baseURL}/email-preference` }, */
    // eslint-disable-next-line object-curly-newline
    /* { id: 9, label: 'Passport', url: `${baseURL}/passport`, userRole: 'P' }, */
    {
        id: 4, label: 'WISHLIST', url: `${baseURL}/wishlist`, userRole: 'P',
    },
    { id: 10, label: 'Sign Out', url: '/auth/logout' },
];

class AccountHome extends React.Component {
    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    getDataTestAttribute = (url) => url.replace(`${baseURL}${'/'}`, '').replace('/auth/logout', 'auth-logout');

    handleListItemClicked = (url) => {
        const { history } = this.props;
        history.push(url);
    };

    render() {
        const {
            classes, userProfile, featureFlags, breakpoint, history, brand,
        } = this.props;
        const breakpointExpr = `(min-width: ${(breakpoint || CUSTOM_BREAKPOINTS.tabLandscape)}px)`;

        return (
            brand?.code === 'PLA'
                ? <ProfileAndPassword />
                : (
                    <Media query={breakpointExpr}>
                        {(matches) => (
                            matches ? (
                                <>
                                    <DesktopAccountHome featureFlags={featureFlags} history={history} userProfile={userProfile} />
                                </>
                            )
                                : (
                                    <>
                                        <h1>{userProfile.firstName}&apos;s Account</h1>
                                        <List
                                            component="nav"
                                            className={classes.root}
                                            data-test="my-account-options"
                                            aria-label="Account"
                                        >
                                            {listItem.map((list) => {
                                                if (
                                                    (list.userRole
                                                        && list.userRole !== userProfile.userRole)
                                                    || (list.flag
                                                        && featureFlags[list.flag]
                                                        && featureFlags[list.flag] === false)
                                                ) {
                                                    return '';
                                                }
                                                return (
                                                    <ListItem
                                                        key={list.id}
                                                        data-test={this.getDataTestAttribute(`${'my-account-option-'}${list.url}`)}
                                                        button
                                                        divider
                                                        onClick={() => this.handleListItemClicked(list.url)}
                                                    >
                                                        <ListItemText
                                                            className="list-item-text"
                                                            primary={list.label}
                                                        />
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </>
                                )

                        )}
                    </Media>
                )
        );
    }
}

AccountHome.defaultProps = {
    history: {},
    userProfile: {},
    featureFlags: {},
    breakpoint: CUSTOM_BREAKPOINTS.tabLandscape,
};

AccountHome.propTypes = {
    classes: object.isRequired,
    history: object,
    userProfile: shape({
        userRole: string.isRequired,
        email: string.isRequired,
        XAtt4: string, // some existing WCS users account don't have the XAttr attributes
        XAtt5: string,
    }),
    featureFlags: object,
    breakpoint: number,
    brand: string.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps)(withRouter(withStyles(styles, { withTheme: true })(AccountHome)));
